import Header from "../_sections/header/Header";

import Introduction from "../_sections/introduction/Introduction";
import Numders from "../_sections/numbers/Numbers";
import SmoothScroll from "../_components/smooth_scroll/SmoothScroll";
import React, { Suspense, Fragment } from "react";

import Footer from "../_sections/footer/Footer";

import { Dispatch } from "../Dispatch";

const Main = () => {
  const Hero = React.lazy(() => import("../_sections/hero/Hero"));

  return (
    <Fragment>
      <div className="w-full mx-auto bg-black  ">
        <Header />

        <Dispatch />

        <Footer />
      </div>
    </Fragment>
  );
};

export default Main;
